import { Component, ViewChild, ViewEncapsulation, OnInit } from "@angular/core";

import {
    CellEditInputType,
    CreateMode,
    DisplayMode,
    GridComponent,
    GridValidator,
    IGridColumn,
    IGridSettings,
    ITableSettings,
    UpdateMode
} from "@features/grid";
import { FilterInputType, FilterType } from "@features/filter";
import { RavenCategoryService } from "../raven-category.service";
import { RavenApiService } from "../raven-api.service";

@Component({
    selector: "raven-category",
    templateUrl: "raven-category-settings.component.html",
    styleUrls: []
})
export class RavenCategorySettingsComponent implements OnInit {
    tableSettings: ITableSettings = {
        lazyLoadOnInit: false
    };
    gridSettings: IGridSettings = {
        deleteAllEnabled: false,
        updateMode: UpdateMode.Inline,
        createMode: CreateMode.Disabled,
        filtersRow: false,
        exportEnabled: false,
        deletingAvailable: (rowData => rowData.canDelete),
    };
    @ViewChild("grid", { static: true }) grid: GridComponent;

    constructor(public ravenCategoryService: RavenCategoryService, public ravenApiService: RavenApiService) {
        this.gridSettings.dataService = ravenCategoryService;
        this.init();
    }

    // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
    ngOnInit(): void {

    }

    check() {
        this.ravenApiService.checkCategories().finally(() => {
            this.grid.reload();
        })
    }

    private async init(): Promise<any> {

        this.tableSettings = {
            columns: <IGridColumn[]>[
                {
                    header: "Category Name",
                    field: "fullName"
                },
                {
                    header: "Short Name",
                    field: "shortName",
                    editableOnCreate: false,
                    editableOnUpdate: false
                },
                {
                    header: "Enabled in Raven",
                    field: "ravenEnabled",
                    trueConditionValue: "Yes",
                    falseConditionValue: "No",
                    editableOnCreate: false,
                    editableOnUpdate: false,
                    displayMode: DisplayMode.Conditional
                },
                {
                    header: "Enabled in ORB",
                    field: "enabled",
                    cellEditingInputType: CellEditInputType.Checkbox,
                    displayMode: DisplayMode.Checkbox,
                }
            ]
        };
    }
}

